import React from "react";
import BeautyLeft from "./../../assets/images/beautyleft.png";
import BeautyRight from "./../../assets/images/beautyright.png";

import "./beauty.css"
const Beauty = () => {
  const shopNow = () => {
    window.open(
      'https://a.co/d/1Tnoxt3',
      '_blank' // <- This is what makes it open in a new window.
    );
  }
  return (
    <div className="beauty" id="about">
    <div className="beauty_left">
        <img src={BeautyLeft} alt=" "/>
    </div>
      <p className="beauty_heading">A NEW GENERATION OF BEAUTY SPONGES</p>
      <p className="beauty_description">
        MIXY Beauty offers high-quality makeup sponges for flawless and
        professional results. Our sponges work with liquid or cream foundations,
        concealers, and contours, made of gentle materials, and easy to clean.
        Our goal is to provide affordable and effective makeup tools to help
        women feel their best for any occasion. Discover MIXY Beauty for all
        your makeup needs.
      </p>
      <button className="primary_btn" onClick={()=> shopNow()}>Shop Now</button>
      <div className="beauty_right">
        <img src={BeautyRight} alt=" "/>
    </div>
    </div>
  );
};

export default Beauty;
